import { config } from '../../../../config.js'
const API = config.apiUrl

const clientSide = [
    {
        redirectToStorage: `${API}/epassportplus`, //Server
        redirectToApp: `${API}/epassport`, //Client
    },
]

module.exports = {
    clientSide: clientSide,
}
